<template>
  <div class="full-screen-layout relative">
    <div class="header flex flex-align-center SB-border bottom">
      <h1
        class="mr-3 flex flex-align-center" >
        <div
          class="back-btn flex flex-align-center"
          @click="goBack('AIAssistants')" >
          <SBIcon
            class="mr-2"
            :icon="SBIconList.DOWN_ARROW"
            :color="SBColors.greyPrimary"
            :size="12"
            :rotate="90" />
          <p class="mr-3">Customize AI assistant</p>
        </div>
        <span class="green-pill mr-3">Beta</span>

        <!-- Web scraping progress -->
        <!-- scrapingInProgress && enableAICreateAndEdit" -->
        <span
          v-if="scrapingData && scrapingData.all && scrapingData.all.percentage && scrapingData.all.percentage < 100"
          class="flex flex-align-center ml-2">
          <CircleSpinner
            :diameter="14"
            :progress="scrapingData.all.percentage"
            :stroke-width="2"
            background="#CFD8DC" />
          <p class="action-text ml-2"><span>{{ scrapingData.all.current | bigDigits }}</span>/{{ scrapingData.all.all | bigDigits }} links crawled...</p>
        </span>
        <span
          v-else-if="scrapeDeleteData && scrapeDeleteData.all && scrapeDeleteData.all.percentage && scrapeDeleteData.all.percentage < 100"
          class="flex flex-align-center ml-2">
          <CircleSpinner
            :diameter="14"
            :progress="scrapeDeleteData.all.percentage"
            :stroke-width="2"
            background="#CFD8DC" />
          <p class="action-text ml-2"><span>{{ scrapeDeleteData.all.current | bigDigits }}</span>/{{ scrapeDeleteData.all.all | bigDigits }} crawled links deleted...</p>
        </span>
        <span
          v-else-if="scrapingInProgress"
          class="flex flex-align-center ml-2">
          <CircleSpinner
            :diameter="14"
            :progress="0"
            :stroke-width="2"
            infinite
            background="#CFD8DC" />
          <p class="action-text ml-2">Web crawl in progress...</p>
        </span>
        <span
          v-else-if="scrapeDeleteData && scrapeDeleteData.all"
          class="flex flex-align-center ml-2">
          <CircleSpinner
            :diameter="14"
            :progress="0"
            :stroke-width="2"
            infinite
            background="#CFD8DC" />
          <p class="action-text ml-2">Deleting crawled links in progress...</p>
        </span>

        <!-- Specific link scraping in progress -->
        <span
          v-if="scrapingData && scrapingData.specific && scrapingData.specific.percentage && scrapingData.specific.percentage < 100"
          class="flex flex-align-center ml-2">
          <CircleSpinner
            :diameter="14"
            :progress="scrapingData.specific.percentage"
            :stroke-width="2"
            background="#CFD8DC" />
          <p class="action-text ml-2"><span>{{ scrapingData.specific.current | bigDigits }}</span>/{{ scrapingData.specific.all | bigDigits }} specific links scraped...</p>
        </span>
        <span
          v-else-if="scrapeDeleteData && scrapeDeleteData.specific && scrapeDeleteData.specific.percentage && scrapeDeleteData.specific.percentage < 100"
          class="flex flex-align-center ml-2">
          <CircleSpinner
            :diameter="14"
            :progress="scrapeDeleteData.specific.percentage"
            :stroke-width="2"
            background="#CFD8DC" />
          <p class="action-text ml-2"><span>{{ scrapeDeleteData.specific.current | bigDigits }}</span>/{{ scrapeDeleteData.specific.all | bigDigits }} scraped links deleted...</p>
        </span>
        <span
          v-else-if="scrapingSpecificLinksInProgress"
          class="flex flex-align-center ml-2">
          <CircleSpinner
            :diameter="14"
            :progress="0"
            :stroke-width="2"
            infinite
            background="#CFD8DC" />
          <p class="action-text ml-2">Scraping specific links in progress...</p>
        </span>
        <span
          v-else-if="scrapeDeleteData && scrapeDeleteData.specific"
          class="flex flex-align-center ml-2">
          <CircleSpinner
            :diameter="14"
            :progress="0"
            :stroke-width="2"
            infinite
            background="#CFD8DC" />
          <p class="action-text ml-2">Deleting scraped specific links in progress...</p>
        </span>

        <!-- File upload progress -->
        <span
          v-if="(fileUploadCounterForAssistant || fileDeleteCounterForAssistant) && enableAICreateAndEdit"
          class="flex flex-align-center ml-3">
          <!-- UPLOAD has a priority over DELETE -->
          <template v-if="fileUploadCounterForAssistant">
            <CircleSpinner
              :diameter="14"
              :progress="fileUploadCounterForAssistant.percentage ? fileUploadCounterForAssistant.percentage : null"
              :stroke-width="2"
              :show-tick="true"
              background="#CFD8DC" />
            <!-- <p
              v-if="filesFinishedUploading && fileUploadStats.failed.length"
              class="action-text ml-2">File upload finished but some files failed.</p>
            <p
              v-if="filesFinishedUploading && !fileUploadStats.failed.length"
              class="action-text ml-2">File upload finished.</p>
            <p
              v-else
              class="action-text ml-2"><span>{{ fileUploadStats.uploaded }}</span> of {{ fileUploadStats.total }} files uploaded...</p> -->
            <p
              v-if="fileUploadCounterForAssistant.percentage && fileUploadCounterForAssistant.percentage === 100"
              class="action-text ml-2">File upload finished.</p>
            <p
              v-else-if="fileUploadCounterForAssistant.percentage >= 0 && fileUploadCounterForAssistant.percentage < 100"
              class="action-text ml-2"><span>{{ fileUploadCounterForAssistant.uploaded }}</span> of {{ fileUploadCounterForAssistant.all }} files processed...</p>
            <p
              v-else
              class="action-text ml-2" >File upload in progress...</p>
          </template>
          <template v-else-if="fileDeleteCounterForAssistant">
            <CircleSpinner
              :diameter="14"
              :progress="fileDeleteCounterForAssistant.percentage ? fileDeleteCounterForAssistant.percentage : null"
              :stroke-width="2"
              :show-tick="true"
              background="#CFD8DC" />
            <p
              v-if="fileDeleteCounterForAssistant.percentage && fileDeleteCounterForAssistant.percentage === 100"
              class="action-text ml-2">File deleting finished.</p>
            <p
              v-else-if="fileDeleteCounterForAssistant.percentage >= 0 && fileDeleteCounterForAssistant.percentage < 100"
              class="action-text ml-2"><span>{{ fileDeleteCounterForAssistant.deleted }}</span> of {{ fileDeleteCounterForAssistant.all }} files deleted...</p>
            <p
              v-else
              class="action-text ml-2" >Deleting files in progress...</p>
          </template>
        </span>
      </h1>
      <span class="greedy" />
      <b-button
        v-if="!noMessages"
        id="clear-btn"
        class="flex center-all"
        :disabled="disabled"
        @click="resetTesting()" >
        <SBIcon
          class="mr-2"
          :icon="SBIconList.TRASH"
          :color="SBColors.blackPrimary"
          :size="12"/>
        <span>Clear chat thread</span>
      </b-button>
    </div>
    <Spinner
      v-if="loadingSchema"
      class="full-width cover mask-spinner"
      :size="20"
      :thickness="2" />
    <div
      id="playground-wrapper"
      class="flex greedy" >
      <div
        id="assistant-editor"
        class="SB-border right no-shrink">
        <div class="flex column h-100">
          <div
            class="greedy"
            style="height: 0;">
            <div
              v-if="!enableAICreateAndEdit"
              class="flex column center-all h-100" >
              <p style="font-size: 42px; ">😊</p>
              <p style="font-size: 14px; font-weight: 500; color: #7c8b91; max-width: 316px; margin-top: 16px; line-height: 1.2; text-align: center;">Soon, you'll be able to edit and fine-tune your AI assistant here. Stay tuned!</p>
            </div>
            <Stepper
              v-else-if="!resetStepper && assistantCreateSteps.length"
              ref="assistantStepperRef"
              :key="assistantUpdatedCounter"
              class="stepper"
              :steps="assistantCreateSteps"
              finish-btn-text="Save"
              type="images"
              :ignore-change-detection="loadingSchema || updatingAssistant"
              jumping
              hide-close
              :edit-message="editMessage"
              edit-mode
              :button-loader="updatingAssistant"
              :reset-override="reloadSchema"
              :initial-step="currentStep"
              :force-cancel-loader="true"
              @abort="() => {}"
              @finish="updateAssistant"
              @scrollToTop="toTop"
              @stepChanged="step => currentStep = step" />
          </div>
        </div>
      </div>
      <div
        id="assistant-playground"
        class="flex column greedy relative" >
        <div
          class="body greedy"
          :class="{ 'no-messages': noMessages }">
          <ScrollArea
            ref="messageScrollbar"
            class="messages-scroll-area"
            :top-offset="100"
          >
            <!-- No messages view -->
            <div
              v-if="noMessages"
              class="flex column center-all">
              <p class="baloon">💬</p>
              <p class="start-title flex center-all">
                <span class="no-shrink ellipsis2">Send a message to start testing</span>
                <span
                  v-if="assistant.avatar"
                  class="no-shrink icon-big ml-2 mr-1"
                  :style="{ backgroundImage: `url(${assistant.avatar})`}" />
                <span class="ellipsis">{{ assistant.name }}</span>
              </p>
              <p class="start-subtitle">Start a conversation with {{ assistant.name }} to test its responses and capabilities.</p>
            </div>

            <!-- Message list view -->
            <div
              v-else
              class="message-list" >
              <div
                class="conversation-start operator-message text-center">
                <!-- <span class="emoji-fix">👋</span> -->
                <h1 class="assistant-name flex center-all"><span
                  v-if="assistant.avatar"
                  class="icon-big ml-2 mr-2"
                  :style="{ backgroundImage: `url(${assistant.avatar})`}" /> {{ assistant.name }}</h1>
              </div>
              <div
                v-for="(messagesChunk, chunkIndex) in messagesChunks"
                :key="chunkIndex"
                class="day-wrapper" >
                <span class="time-flag">
                  <p
                    v-if="chunkIndex === 0"
                    class="start-info flex center-all px-2" >
                    <SBIcon
                      class="mr-2"
                      :icon="SBIconList.INFO"
                      :color="SBColors.greyLight"
                      :size="12"/>Playground doesn't support sending follow-up messages. Use WhatsApp for the full testing experience.</p>
                  <p v-else >
                    {{ messagesChunk[0].timestamp | messagesMainDate }}</p>
                </span>
                <div
                  v-for="(message, messageIndex) in messagesChunk"
                  :id="`message-${message.sid}`"
                  :key="messageIndex"
                  class="message-wrapper"
                  :class="[
                    {
                      'small-top-margin': (messageIndex === 0) || (messageIndex > 0 && showSubMessage(messagesChunk[messageIndex - 1], message)),
                      error: message.type === 'error',
                    },
                    $options.filters.hyphen(message.direction)
                  ]" >
                  <div
                    v-if="message.direction !== 'activity'"
                    :id="`message-target-${message.sid}`"
                    class="message"
                    @mouseenter="showTooltip(message.sid)"
                    @mouseleave="hideTooltip(message.sid)" >
                    <ContextPreview
                      v-if="message.context_preview && message.context_preview.length"
                      class="ml-auto"
                      :class="{ first: message.body }"
                      :context-message="message" />
                    <div
                      v-if="message.context"
                      class="reply-message-origin" >
                      <div class="header flex flex-align-center">
                        <SBIcon
                          class="mr-1"
                          :icon="SBIconList.REPLY_SINGLE"
                          :color="SBColors.blackUltralight"
                          :size="9" />
                        <p>Replied to {{ message.direction === 'inbound' ? (message.context.direction === 'inbound' ? 'themself' : 'you') : (message.context.direction === 'inbound' ? (activeConversation.contact.name ? activeConversation.contact.name : activeConversation.contact.phone) : 'yourself') }}</p>
                      </div>
                      <div class="body">
                        <MediaMessage
                          v-if="isMediaMessage(message.context)"
                          :message="message.context"
                          force-black />
                        <LocationMessage
                          v-else-if="
                            (message.context.media_type && message.context.media_type === 'location') ||
                              (message.context.type && message.context.type === 'location')
                          "
                          :location="message.context.media_url || message.context.body"
                        />
                        <p
                          v-else
                          :class="{ 'text-arabic': isRightAlignedText(message.context.body || '') }"
                          class="text-message"
                        >
                          <MessageContent
                            :content="message.context.body"
                            :detect-urls="true" />
                        </p>
                      </div>
                    </div>
                    <div
                      class="body-wrapper flex flex-align-center">
                      <div class="message-elements flex column relative" >
                        <SBIcon
                          v-if="message.status === 'failed'"
                          :id="`message-failed-info-${message.sid}`"
                          class="message-info"
                          :class="{ 'message-info': !isMediaMessage(message) }"
                          :icon="SBIconList.INFO"
                          color="#f5bfc1"
                          :size="12"
                          :hover-size="24" />
                        <div
                          class="message-body flex flex-align-center"
                          :class="[
                            messagePositionInGroup(
                              messagesChunk[messageIndex - 1],
                              messagesChunk[messageIndex],
                              messagesChunk[messageIndex + 1]
                            ),
                            {
                              'has-buttons': message.buttons,
                              failed: message.status === 'failed',
                            },
                          ]"
                        >
                          <MediaMessage
                            v-if="isMediaMessage(message)"
                            :message="message" />
                          <LocationMessage
                            v-else-if="(message.media_type && message.media_type === 'location') ||
                              (message.type && message.type === 'location')"
                            :location="message.media_url || message.body"
                          />
                          <p
                            v-else
                            :class="{ 'text-arabic': isRightAlignedText(message.body || '') }"
                            class="text-message"
                          >
                            <MessageContent
                              :content="message.body"
                              :detect-urls="true" />
                            <template v-if="message.actions">
                              <span
                                v-for="action in message.actions"
                                :key="action._id"
                                class="message-action"
                              >
                                {{ action.text ? `${action.text} ` : "" }}
                                <a
                                  v-if="action.type === 'link'"
                                  :href="action.uri"
                                  target="_blank"
                                >{{ action.uri }}</a
                                >
                              </span>
                            </template>
                          </p>
                        </div>
                        <MessageButtons
                          v-if="message.buttons"
                          :message="message"
                          pointer
                          :class="[
                            messagePositionInGroup(
                              messagesChunk[messageIndex - 1],
                              messagesChunk[messageIndex],
                              messagesChunk[messageIndex + 1]
                            )
                          ]"
                          @button-click="buttonClicked" />
                      </div>
                    </div>

                    <div
                      v-if="showSubMessage(message, messagesChunk[messageIndex + 1])"
                      class="sub-message"
                    >
                      <template v-if="message.reasoning">
                        <div
                          :id="`thoughts-${message.sid}`"
                          class="flex ai-sources" >
                          <SBIcon
                            :icon="SBIconList.BULB"
                            :color="SBColors.blackUltralight"
                            :size="12"
                            class="mr-1" />
                          <p class="" >Thoughts</p>
                        </div>
                        <DotSeparator
                          :size="3"
                          class="ml-1 mr-1" />
                        <b-popover
                          :id="`thoughts-${message.sid}-popover`"
                          :target="`thoughts-${message.sid}`"
                          triggers="hover"
                          placement="top"
                          custom-class="thoughts-popover"
                          boundary-padding="0" >
                          <div
                            v-for="(thought, index) in message.thoughts"
                            :key="index"
                            class="flex column ai-thought" >
                            <h3 v-if="thought.title">{{ thought.title }}</h3>
                            <p v-if="thought.description">{{ thought.description }}</p>
                          </div>
                        </b-popover>
                      </template>
                      <template v-if="message.sources && message.sources.length">
                        <div
                          :id="`sources-${chunkIndex}-${messageIndex}`"
                          class="flex ai-sources" >
                          <SBIcon
                            :icon="SBIconList.ADD_FILES"
                            :color="SBColors.blackUltralight"
                            :size="12"
                            class="mr-1" />
                          <p class="" >{{ message.sources.length }} source{{ message.sources.length > 1 ? 's' : '' }}</p>
                        </div>

                        <DotSeparator
                          :size="3"
                          class="ml-1 mr-1" />

                        <b-popover
                          ref="openPopoverRef"
                          :target="`sources-${chunkIndex}-${messageIndex}`"
                          triggers="hover"
                          placement="bottom"
                          custom-class="sources-popover"
                          boundary-padding="0" >
                          <h3>{{ message.sources.length }} source{{ message.sources.length > 1 ? 's' : '' }}</h3>
                          <a
                            v-for="(source, index) in message.sources"
                            :key="index"
                            :href="source.url"
                            target="_blank"
                            class="d-block flex flex-align-center" >
                            <SBIcon
                              :icon="source.name.indexOf('http') === 0 ? SBIconList.FOLDER_TICK : SBIconList.TICK_FILE"
                              :color="SBColors.blackPrimary"
                              :size="12"
                              class="mr-1" />
                            <p class="m-0 ellipsis">{{ source.name | domainSimplified }}</p>
                            <SBIcon
                              :icon="SBIconList.ARROW_45"
                              :color="SBColors.greyPrimary"
                              :size="12"
                              class="mr-1" />
                          </a>
                        </b-popover>
                      </template>

                      <template v-if="message.direction === 'inbound'">
                        <SBIcon
                          :icon="SBIconList.PROFILE_FILLED_CIRCLE"
                          :color="SBColors.blackUltralight"
                          :size="12"
                          class="mr-1" />
                        <p class="">Contact</p>
                      </template>
                      <template v-else>
                        <span
                          v-if="assistant.avatar"
                          class="icon-submessage mr-1"
                          :style="{ backgroundImage: `url(${assistant.avatar})`}" />
                        <p class="">{{ assistant.name }}</p>
                      </template>

                      <DotSeparator
                        :size="3"
                        class="ml-1 mr-1" />

                      <p>
                        {{ message.timestamp | subMessageDate }}
                      </p>
                    </div>
                  </div>
                  <div
                    v-else
                    class="operator-message flex center-all">
                    <!-- <SBIcon
                      v-if="message.direction === 'activity' && message.action === 'Block'"
                      class="mr-1"
                      :icon="SBIconList.BLOCK"
                      :color="SBColors.blackUltralight"
                      :size="12" /> -->
                    <p>
                      <span
                        v-if="message.body.emoji"
                        class="emoji-fix">{{ message.body.emoji }}</span>
                      {{ message.body.text || message.body }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ScrollArea>
          <DropHere force />
          <PasteImageModal
            ref="pasteImageModalRef"
            emit-mode
            :max-files="1"
            max-file-error-message="Sending multiple media files is not allowed in the playground."
            hide-quick-replies-button
            @media="newMedia" />
        </div>
        <div class="footer">
          <MessageInput
            ref="messageInputRef"
            class="footer-input"
            :focus-shadow="true"
            testing
            :block-send="disabled"
            hide-quick-replies-button
            hide-template-button
            emit-audio
            @testing="newMessage"
            @audio="newAudio" />
          <div class="info flex center-all">
            <SBIcon
              :icon="SBIconList.INFO"
              :color="SBColors.greyLight"
              :size="10"
              class="mr-1" />
            <p>Test messages are not saved in cloud storage and will be included in your AI response billing count.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from '@/helpers/momentz';
import { mapGetters, mapActions } from 'vuex';

import DropHere from '@/components/common/DropHere';
import CircleSpinner from '@/components/animatedIcons/CircleSpinner';
import { isRightAlignedText } from '@/helpers/stringHelpers';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import MessageInput from '@/components/business/chat/partials/MessageInput';
import ScrollArea from '@/components/common/ScrollArea';
import randomString from '@/helpers/randomString';
import DotSeparator from '@/components/common/DotSeparator';
import MessageContent from '@/components/common/MessageContent';
import MessageButtons from '@/components/business/chat/partials/MessageButtons';
import CommonActions from '@/components/manage/CommonActions.mixin';
import api from '@/helpers/api';
import Spinner from '@/components/common/Spinner';
import ToasterMixin from '@/mixins/Toaster';
import MediaMessage from '@/components/business/chat/partials/MediaMessage';
import LocationMessage from '@/components/business/chat/partials/LocationMessage';
import Stepper from '../common/Stepper';
import StepperJsonSchemaBlank from './StepperJsonSchemaBlank';
import StatusTypes from '../../helpers/enums/statusTypes.enum';
import { populateEmptySchema, createFormSchemaBodyFormat, populateFormBody } from '../forms_schema/formSchema.helpers';
import PasteImageModal from '../business/notifications/modals/PasteImageModal';

export default {
  name: 'AIAssistantTest',
  components: {
    DropHere,
    PasteImageModal,
    SBIcon,
    MessageInput,
    ScrollArea,
    DotSeparator,
    MessageContent,
    MessageButtons,
    Stepper,
    Spinner,
    CircleSpinner,
    MediaMessage,
    LocationMessage,
  },
  mixins: [
    CommonActions,
    ToasterMixin,
  ],
  beforeRouteLeave(to, from, next) {
    if (this.$refs && this.$refs.assistantStepperRef) {
      // Notify stepper about the route change and let it decide if it should allow it.
      this.$refs.assistantStepperRef.navigateAway(next);
    } else {
      next();
    }

    this.removeBackgroundAction({
      assistantId: this.assistantId,
      action: 'webScrape',
    });
  },
  data() {
    return {
      disabled: false,
      messages: [],
      clearing: false,
      postponedMessage: null,
      loadingSchema: true,
      assistantsFormSchema: {},
      fileUploadStats: {
        total: 0,
        uploaded: 0,
        failed: 0,
      },
      editMessages: {},
      initData: null,
      SBIconList,
      SBColors,
      preventNewEditMessage: null,
      updatingAssistant: false,
      // Use this if the component needs to be reloaded when the updated assistant but try to avoid it because the component resets itself.
      assistantUpdatedCounter: 0,
      assistantDataSavedSystemMessageShown: false,
      toasterTypeMap: {
        error: 'error',
        warning: 'warning',
        success: 'OK',
      },
      sendMessageTimeout: null,
      currentStep: 0,
      resetStepper: false,
    };
  },
  computed: {
    ...mapGetters({
      membersLookup: 'organisation/currentOrganisationMembersLookup',
      aiAssistants: 'organisation/aiAssistants',
      currentOrganisation: 'organisation/currentOrganisation',
      backgroundActions: 'automation/backgroundActions',
      assistantDataSaved: 'automation/assistantDataSaved',
      scrapingStatus: 'automation/scrapingStatus',
      enableAICreateAndEdit: 'organisation/enableAICreateAndEdit',
      aiAssistantMessages: 'pusher/aiAssistantMessages',
      webScrapeCounter: 'automation/webScrapeCounter',
      webScrapeDeleteCounter: 'automation/webScrapeDeleteCounter',
      fileUploadCounter: 'automation/fileUploadCounter',
      fileDeleteCounter: 'automation/fileDeleteCounter',
    }),
    assistantCreateSteps() {
      const steps = [];
      if (this.assistantsFormSchema && this.assistantsFormSchema.scheme && this.assistantsFormSchema.scheme.steps) {
        this.assistantsFormSchema.scheme.steps.forEach((step, index) => {
          steps.push({
            component: StepperJsonSchemaBlank,
            stepImage: step.icon,
            dat: {
              stepName: `step-${index}`,
              title: step.title,
              subtitle: step.subtitle,
              jsonSchema: step.formSchema,
              index,
            },
          });
        });
      }

      return steps;

      return [
        // CreateAssistantFirstStep,
        // CreateAssistantSecondStep,
        // CreateAssistantThirdStep,
        // CreateAssistantForthStep,
      ];
    },
    assistant() {
      const targetAssistant = this.aiAssistants && Array.isArray(this.aiAssistants) ? this.aiAssistants.find(assistant => assistant.uid === this.assistantId) : null;
      return targetAssistant || {};
    },
    editMessage() {
      let finalMessage = 'Save to apply changes';
      if (Object.keys(this.editMessages).length) {
        let editMessagesValues = Object.values(this.editMessages);
        if (Object.keys(this.editMessages).length > 1) {
          const tempEditMessagesObject = JSON.parse(JSON.stringify(this.editMessages));
          delete tempEditMessagesObject.default;
          editMessagesValues = Object.values(tempEditMessagesObject);
        }
        // let changes = editMessagesValues.shift();
        let changes = '';
        editMessagesValues.forEach((message, index) => {
          changes += editMessagesValues.length === index + 1 ? ' and ' : ', ';
          changes += message;
        });
        finalMessage += changes;
      }
      return `${finalMessage}.`;
    },
    fileUploadProgress() {
      return this.fileUploadStats.total ? (this.fileUploadStats.uploaded) / this.fileUploadStats.total * 100 : 0;
    },
    fileUploadCounterForAssistant() {
      return this.fileUploadCounter[this.assistantId];
    },
    fileDeleteCounterForAssistant() {
      return this.fileDeleteCounter[this.assistantId];
    },
    filesUploading() {
      return (this.backgroundActions.filter(ba => ba.action === 'uploadAiFiles').length > 0 && !!this.fileUploadStats.total);
    },
    filesFinishedUploading() {
      return this.backgroundActions.filter(ba => ba.action === 'uploadAiFiles').every(ba => ba.status === StatusTypes.COMPLETED);
    },
    scrapingInProgress() {
      return this.backgroundActions.filter(ba => ba.assistantId === this.assistantId && ba.action === 'webScrape' && ba.type === 'all' && ba.status === StatusTypes.RUNNING).length > 0;
    },
    scrapingSpecificLinksInProgress() {
      return this.backgroundActions.filter(ba => ba.assistantId === this.assistantId && ba.action === 'webScrape' && ba.type === 'specific' && ba.status === StatusTypes.RUNNING).length > 0;
    },
    noMessages() {
      return this.messages.length === 0;
    },
    messagesChunks() {
      const chunks = [];
      let tempChunk = [];

      this.messages.forEach((message, index) => {
        if (!message.timestamp) {
          message.timestamp = message.sent_at ? message.sent_at : (message.data && message.data.timestamp ? message.data.timestamp : Date.now());
        }
        if (!message.file_sources && message.data && message.data.file_sources) {
          message.file_sources = message.data.file_sources;
        }
        if (message.reasoning) {
          message.thoughts = this.parseThoughts(message.reasoning);
          message.sid = Date.now();
        }
        if (
          tempChunk.length &&
          index > 0 &&
          !this.isSameDay(message.timestamp, this.messages[index - 1].timestamp)
        ) {
          chunks.push(tempChunk);
          tempChunk = [];
        }
        tempChunk.push(message);
      });

      if (tempChunk.length) {
        chunks.push(tempChunk);
      }

      return chunks;
    },
    lastMessageBeforeYesterday() {
      let before = false;
      if (!this.messagesChunks || !this.messagesChunks[0] || !this.messagesChunks[0][0]) {
        return before;
      }
      let valueMoment;
      if (this.messagesChunks[0][0].timestamp.toString().indexOf('-') >= 0) {
        valueMoment = moment(this.messagesChunks[0][0].timestamp);
      } else {
        valueMoment = moment(false, false).unix(this.messagesChunks[0][0].timestamp);
      }

      if (!valueMoment.isSame(Date.now(), 'day') && !valueMoment.isSame(moment().subtract(1, 'days'), 'day')) {
        before = true;
      }
      return before;
    },
    organisationId() {
      return this.$route.params.organisationId;
    },
    scrapingData() {
      return this.webScrapeCounter[this.assistantId];
    },
    scrapeDeleteData() {
      return this.webScrapeDeleteCounter[this.assistantId];
    },
    assistantId() {
      return this.$route.params.assistantId;
    },
  },
  watch: {
    aiAssistantMessages: {
      handler() {
        const threadUidsLocalStorage = JSON.parse(localStorage.getItem('threadUids')) || {};
        if (this.aiAssistantMessages && this.aiAssistantMessages.thread_uid === threadUidsLocalStorage[this.assistantId]) {
          clearTimeout(this.sendMessageTimeout);
          this.enableControl();
          let responseMessages = [];
          if (Array.isArray(this.aiAssistantMessages.messages)) {
            responseMessages = [...this.aiAssistantMessages.messages];
          } else {
            responseMessages.push({ body: this.aiAssistantMessages.messages });
          }
          // for testing sources
          // const sources = [
          //   {
          //     "url": "https://nasa.domena.com/path-do-filea111111",
          //     "name": "https://neko-ime-fajla.pdfdfi kudfs gushiu hfiuh giushiu hiufgh iushfilu ghlsiuf hilu fgnln lsufil nilh sfiglu"
          //   },
          //   {
          //     "url": "https://nasa.domena.com/path-do-filea222222",
          //     "name": "https://neko-ime-fajla.pdf"
          //   },
          //   {
          //     "url": "https://nasa.domena.com/path-do-filea222222",
          //     "name": "neko-ime-fajla.pdf"
          //   },
          //   {
          //     "url": "https://nasa.domena.com/path-do-filea333333",
          //     "name": "https://neko-ime-fajla.pdf"
          //   },
          // ];
          responseMessages.forEach((res, index) => {
            let scrollDown = false;
            if (this.$refs.messageScrollbar.isPositionedOnBottom()) {
              scrollDown = true;
            }
            this.messages.push({
              ...res,
              type: res.message_type,
              direction: res.direction || 'outbound',
              from: (this.aiAssistantMessages.ai_assistant_uid || 'system'),
              timestamp: (this.aiAssistantMessages.sent_at || this.$moment().unix()),
            });
            if (index === responseMessages.length - 1 && this.aiAssistantMessages.sources && this.aiAssistantMessages.sources.length) {
              this.messages[this.messages.length - 1].sources = this.aiAssistantMessages.sources;
            }
            if (index === responseMessages.length - 1 && this.aiAssistantMessages.reasoning && this.aiAssistantMessages.reasoning.length) {
              this.messages[this.messages.length - 1].reasoning = this.aiAssistantMessages.reasoning;
            }
            if (scrollDown) {
              this.$nextTick(() => {
                this.$refs.messageScrollbar.scrollToBottom();
              });
            }
          });
        }
      },
      deep: true,
      immediate: false,
    },
    backgroundActions: {
      handler() {
        this.calculateFileUploadStats();

        // Handling web scrape actions
        // scraping is in progresss in multiple cases
        // 1. when there is a webScrape action in progress
        // 2. when there is a domainLinksScrapeFinished parameter set to null on the scheme
        // 3. when there is a specificLinksScrapeFinished parameter set to null on the scheme
        let scraping = false;
        const webScrapeActionsRunning = this.backgroundActions.filter(
          ba => ba.assistantId === this.assistantId &&
            ba.action === 'webScrape' &&
            [StatusTypes.RUNNING, StatusTypes.PENDING].includes(ba.status),
        );
        if (webScrapeActionsRunning.length > 0) {
          scraping = true;
        }
        if (this.schema && this.schema.domainLinksScrapeFinished === false) {
          if (!webScrapeActionsRunning.find(action => action.type === 'all')) {
            scraping = true;
          }
        }
        if (this.schema && this.schema.specificLinksScrapeFinished === false) {
          if (!webScrapeActionsRunning.find(action => action.type === 'specific')) {
            scraping = true;
          }
        }
        // This one is just for legacy reasons so it doesn't brake enything. It should be removed when the new schema is implemented.
        if (this.schema && this.schema.scrapeFinished === false) {
          scraping = true;
        }

        this.setScrapingStatus({
          assistantId: this.assistantId,
          status: scraping,
        });
      },
      deep: true,
      immediate: true,
    },
    assistantDataSaved() {
      // console.log('ASSISTANT MADE CHANGES', this.assistantDataSaved);
      // Check if it is the right assistant because the toast is shown only if the change is on the assistant the user is trying to edit at the moment.
      if (!this.assistantDataSavedSystemMessageShown && this.assistantId === this.assistantDataSaved.assistantId) {
        const targetAssistant = this.aiAssistants && Array.isArray(this.aiAssistants) ? this.aiAssistants.find(assistant => assistant.uid === this.assistantId) : null;
        const data = {
          id: randomString(10),
          code: 'assistantDataSaved',
          action: 'restart',
          message: `Your teammate just updated <img style="height: 13px; position: relative; top: 1px;" src="${targetAssistant.avatar}" /> ${targetAssistant.name}.`,
        };
        this.showSystemMessage(data, null, null, { text: 'REFRESH FORM' }, '⚠️', true, this.refreshPlayground);
        this.assistantDataSavedSystemMessageShown = true;
      }
      // find assistant and add its namr to the toast - Skipp for now because memberId is not provided
      // this.showToaster(`<span class="emoji-fix">✏️</span> ${this.member.name} just updated the ${assistant.name}.`);
    },
    enableAICreateAndEdit: {
      handler() {
        if (!this.enableAICreateAndEdit) {
          this.loadingSchema = false;
        }
      },
      immediate: true,
    },
    scrapingInProgress() {
      if (!this.scrapingInProgress) {
        // handeled from pusher but if needed we can combine both events here (specific, entire).
        // window.eventBus.$emit('show-toast', { message: 'Web scrape has been successfully completed.', variant: 'OK' });
      }
    },
  },
  beforeDestroy() {
    this.clearNewSchemaValues();
    this.resetTempFileCounter(this.assistantId);
  },
  mounted() {
    this.clearFileChangeCounter();
    this.resetTempFileCounter(this.assistantId);
    this.resetTesting();
    this.calculateFileUploadStats();

    if (!this.assistantId) {
      this.fetchAiAssistants();
    } else {
      this.getAssistantScheme();
    }
    window.eventBus.$on('wakeup', this.softReset);

    this.$eventBus.$on('editMessage', (data) => {
      this.$nextTick(() => {
        if (this.preventNewEditMessage) {
          clearTimeout(this.preventNewEditMessage);
          this.preventNewEditMessage = setTimeout(() => {
            this.preventNewEditMessage = null;
            this.$eventBus.$emit('resetInitialData');
          }, 1000);
        } else {
          this.$set(this.editMessages, data.key, data.message);
        }
      });
    });
    this.$eventBus.$on('clearEditMessage', () => {
      this.preventNewEditMessage = setTimeout(() => {
        this.preventNewEditMessage = null;
        this.$eventBus.$emit('resetInitialData');
      }, 1000);
      this.$set(this, 'editMessages', {});
      // this.$eventBus.$emit('resetInitialData');
    });

    // Check if there is a data parameter and set the initial data to the form
    if (this.$route.params && this.$route.params.data) {
      this.$set(this, 'initData', JSON.parse(this.$route.params.data));
    }

    window.eventBus.$on('assistant-toast', (data) => {
      if (data.assistantId === this.assistantId) {
        window.eventBus.$emit('show-toast', { message: data.message, variant: data.variant });
      }
    });

    window.eventBus.$on('close-system-message', (code) => {
      if (code === 'assistantDataSaved') {
        this.assistantDataSavedSystemMessageShown = false;
      }
    });

    window.eventBus.$on('stepperInitialized', () => {
      this.loadingSchema = false;
      this.toTop();
    });

    this.$root.$on('bv::popover::show', (bvEventObj) => {
      bvEventObj.target.classList.add('active');
    });
    this.$root.$on('bv::popover::hide', (bvEventObj) => {
      bvEventObj.target.classList.remove('active');
    });
  },
  methods: {
    ...mapActions({
      fetchAiAssistants: 'organisation/fetchAiAssistants',
      updateLocalAssistant: 'organisation/updateLocalAssistant',
      addBackgroundActions: 'automation/addBackgroundActions',
      setNewSchemaValues: 'automation/setNewSchemaValues',
      removeBackgroundAction: 'automation/removeBackgroundAction',
      setScrapingStatus: 'automation/setScrapingStatus',
      clearFileChangeCounter: 'automation/clearFileChangeCounter',
      clearNewSchemaValues: 'automation/clearNewSchemaValues',
      clearToggleElements: 'flows/clearToggleElements',
      clearStepperDataStore: 'helpers/clearStepperDataStore',
      resetTempFileCounter: 'automation/resetTempFileCounter',
      clearBackgroundActions: 'automation/clearBackgroundActions',
      removeAllCounters: 'automation/removeAllCounters',
    }),
    isRightAlignedText,
    refreshPlayground() {
      this.clearFileChangeCounter();
      this.removeAllCounters();
      this.resetTempFileCounter(this.assistantId);
      this.loadingSchema = true;
      this.assistantsFormSchema = {};
      return this.getAssistantScheme();
    },
    calculateFileUploadStats() {
      const fileUploadStats = {
        total: 0,
        uploaded: 0,
        failed: 0,
      };
      this.backgroundActions.filter(ba => ba.assistantId === this.assistantId).forEach((action) => {
        if (action.action === 'uploadAiFiles') {
          fileUploadStats.total += action.data ? action.data.value : 0;
          fileUploadStats.uploaded += action.results ? action.results.success.length : 0;
          fileUploadStats.failed += action.results ? action.results.failed.length : 0;
        }
      });
      this.fileUploadStats = fileUploadStats;
    },
    parseThoughts(thoughts) {
      const regex = /^(\*\*(.*?)\*\*){0,1}(.*)$/s;
      const parsedThoughts = [];
      thoughts.forEach((reasoning) => {
        const match = reasoning.match(regex);
        if (match) {
          parsedThoughts.push({
            title: match[2],
            description: match[3],
          });
        }
      });
      return parsedThoughts;
    },
    getAssistantScheme(showSpinner = true) {
      this.loadingSchema = showSpinner;
      let endpoint = `organisation/${this.currentOrganisation.id}/assistant/${this.$route.params.assistantId}`;
      if (this.$route.params && this.$route.params.data) {
        endpoint = `organisation/${this.currentOrganisation.id}/assistant/empty-scheme`;
      }

      const response = api('GET', endpoint, null, null, 'w');
      response
        .then((response) => {
          // this.assistantsFormSchema = {};
          this.$nextTick(() => {
            if (this.$route.params && this.$route.params.data) {
              this.assistantsFormSchema = populateEmptySchema(response.data, this.initData);
            } else {
              this.assistantsFormSchema = response.data;
            }
            // this.assistantsFormSchema = { ...this.assistantsFormSchema };
          });
        })
        .catch((error) => {
          if (error.response.status === 403) {
            setTimeout(() => {
              // NOTE: this is used just for blocking the UI for a while until we enable this to all the users
              this.loadingSchema = false;
            }, 2000);
          }
        });
      return response;
    },
    getMemberAvatar(message) {
      const member = Object.values(this.membersLookup).find(member => member.platform_id === message.sender_icon);
      if (member) {
        return member;
      }
      return {
        avatar: '',
      };
    },
    closeTesting() {
      this.$router.push({
        name: 'AIAssistants',
      });
    },
    resetTesting() {
      this.clearing = true;
      this.messages = [];
      const threadUidsLocalStorage = JSON.parse(localStorage.getItem('threadUids')) || {};
      api('POST', `/organisation/${this.organisationId}/assistant/${this.assistantId}/test/reset-thread`, { thread_uid: threadUidsLocalStorage[this.assistantId] }, null, 'w').then((response) => {
        if (response.status === 200 && response.data && response.data.thread_uid) {
          const threadUidsLocalStorage = JSON.parse(localStorage.getItem('threadUids')) || {};
          threadUidsLocalStorage[this.assistantId] = response.data.thread_uid;
          localStorage.setItem('threadUids', JSON.stringify(threadUidsLocalStorage));
        }
      }).catch(() => {
        // console.log(error);
      }).finally(() => {
        this.clearing = false;
        if (this.postponedMessage) {
          this.postMessage(this.postponedMessage);
        }
      });
    },
    buttonClicked(button) {
      this.newMessage(button.title);
    },
    newMedia(media) {
      const mediaType = media.message.media_type;
      this.sendMessage({
        sid: randomString(10),
        body: ['image', 'video'].includes(mediaType) ? media.message.body : '',
        title: !['image', 'video'].includes(mediaType) ? media.message.body : '',
        from: 'system',
        timestamp: this.$moment().unix(),
        direction: 'inbound',
        media_type: media.message.media_type,
        media_url: media.message.media_url,
      }, media.data);
    },
    newAudio(audio) {
      this.sendMessage({
        sid: randomString(10),
        body: '',
        from: 'system',
        timestamp: this.$moment().unix(),
        direction: 'inbound',
        media_type: 'audio',
        media_url: audio.fileData.url,
      }, audio.formData);
    },
    newMessage(message) {
      this.sendMessage({
        sid: randomString(10),
        body: message,
        from: 'system',
        timestamp: this.$moment().unix(),
        direction: 'inbound',
        // sender.name === 'contact'
      });
    },
    sendMessage(message, media) {
      if (this.disabled) {
        return;
      }
      const formData = media || new FormData();
      this.disableControl();
      this.messages.push(message);
      this.$nextTick(() => {
        this.$refs.messageScrollbar.scrollToBottom();
      });

      if (message.body) formData.append('text', message.body);
      const threadUidsLocalStorage = JSON.parse(localStorage.getItem('threadUids')) || {};
      formData.append('thread_uid', threadUidsLocalStorage[this.assistantId]);
      if (this.clearing) {
        this.postponedMessage = formData;
      } else {
        this.postMessage(formData);
      }
    },
    postMessage(data) {
      api(
        'POST',
        `organisation/${this.organisationId}/assistant/${this.assistantId}/test/send-message`,
        data,
        { 'Content-Type': 'multipart/form-data' },
        'w',
      )
        .then((response) => {})
        .catch(() => {
          this.messages.push({
            sid: randomString(10),
            body: 'An Error occurred. Please try again in a couple of minutes or clear chat thread and try again.',
            from: 'system',
            timestamp: this.$moment().unix(),
            direction: 'outbound',
            type: 'error',
          });
          this.enableControl();
        }).finally(() => {
          this.postponedMessage = null;
          // this.enableControl();
          clearTimeout(this.sendMessageTimeout);
          this.sendMessageTimeout = setTimeout(() => {
            // Timeout is cleared on pusher message but if pusher message is not received in 10 minutes then the control is enabled, and the error message is shown.
            this.enableControl();
            // also show error message
            this.messages.push({
              sid: randomString(10),
              body: 'An Error occurred. Please try again in a couple of minutes or clear chat thread and try again.',
              from: 'system',
              timestamp: this.$moment().unix(),
              direction: 'outbound',
              type: 'error',
            });
          }, 10 * 60 * 1000);
        });
    },
    disableControl() {
      this.disabled = true;
    },
    enableControl() {
      this.disabled = false;
    },
    isSameDay(testDate, compareDate) {
      return moment(false, false)
        .unix(testDate)
        .isSame(moment(false, false).unix(compareDate), 'day');
    },
    isMediaMessage(message) {
      return !!(
        message.media_type &&
        message.media_type !== 'location' &&
        message.media_url
      );
    },
    showSubMessage(focusMessage, nextMessage) {
      let showIt = false;
      if (
        this.incognito ||
        !nextMessage ||
        focusMessage.status === 'failed' ||
        nextMessage.status === 'failed' ||
        (nextMessage && focusMessage.direction !== nextMessage.direction) ||
        (nextMessage &&
          !this.isLessThanAMinuteApart(focusMessage.timestamp, nextMessage.timestamp)) ||
        (nextMessage && nextMessage.context) ||
        (focusMessage.sender !== nextMessage.sender) ||
        (focusMessage.context_preview && focusMessage.context_preview.length) ||
        (nextMessage.context_preview && nextMessage.context_preview.length)
      ) {
        showIt = true;
      }
      return showIt;
    },
    isInDynPopover(currentElement, id) {
      return currentElement.closest(`.dyn-popover-${id}`);
    },
    isInMessage(currentElement, id) {
      return currentElement.closest(`#message-target-${id}`);
    },
    showTooltip(messageSid) {
      if (this.$refs[`message-failed-info-ref-${messageSid}`]) this.$refs[`message-failed-info-ref-${messageSid}`][0].$emit('open');
    },
    hideTooltip(messageSid) {
      setTimeout(() => {
        const currentElement = document.elementFromPoint(window.mouse.x, window.mouse.y);
        const popoverElement = this.isInDynPopover(currentElement, messageSid);
        const inMessage = this.isInMessage(currentElement, messageSid);
        if (popoverElement || inMessage) {
          // set listener on popover leave
          if (popoverElement) {
            popoverElement.addEventListener('mouseleave', () => {
              this.hideTooltip(messageSid);
            });
          }
        } else if (this.$refs[`message-failed-info-ref-${messageSid}`]) {
          this.$refs[`message-failed-info-ref-${messageSid}`][0].$emit('close');
        }
      }, 50);
    },
    isLessThanAMinuteApart(previousMessage, focusMessage) {
      const secondsDiff = Math.abs(
        moment(false, false)
          .unix(focusMessage)
          .diff(moment(false, false).unix(previousMessage), 'seconds'),
      );
      return secondsDiff >= 0 && secondsDiff < 60;
    },
    messagePositionInGroup(previousMessage, focusMessage, nextMessage) {
      const positions = [];
      // Message can have more than one position. e.g. it can be first but also the last one in the block
      // First if minute is different than the previous message or if the direction is different.
      if (
        !focusMessage.context_preview &&
        (
          !previousMessage ||
          previousMessage.context_preview ||
          focusMessage.status === 'failed' ||
          previousMessage.status === 'failed' ||
          (previousMessage && previousMessage.direction !== focusMessage.direction) ||
          (previousMessage &&
            !this.isLessThanAMinuteApart(previousMessage.timestamp, focusMessage.timestamp)) ||
          (focusMessage.sender !== previousMessage.sender) ||
          (focusMessage && focusMessage.context)
        )
      ) {
        positions.push('first');
      }

      // Middle if the minute is the same as as previous message and the direction is the same
      // but there is no need to return the middle result.

      // Last if the minute is different than the next message or the direction is different than the next message.
      if (
        !nextMessage ||
        focusMessage.status === 'failed' ||
        nextMessage.status === 'failed' ||
        (nextMessage && nextMessage.direction !== focusMessage.direction) ||
        (nextMessage &&
          !this.isLessThanAMinuteApart(nextMessage.timestamp, focusMessage.timestamp)) ||
        (nextMessage && nextMessage.context) ||
        (focusMessage.sender !== nextMessage.sender) ||
        focusMessage.context_preview ||
        nextMessage.context_preview
      ) {
        positions.push('last');
      }

      return positions;
    },
    toTop() {
      if (!this.$refs.assistantStepperRef || !this.$refs.assistantStepperRef.$el) return;
      this.$refs.assistantStepperRef.$el.scrollTop = 0;
    },
    showCreateAssistantError(error = null) {
      if (error && error.response && error.response.data && error.response.data.messages) {
        if (error.response.data.messages && Array.isArray(error.response.data.messages)) {
          error.response.data.messages.forEach((message) => {
            this.showToaster(message.message, null, null, this.toasterTypeMap[message.type]);
          });
        }
      } else {
        // const message = error && error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Something went wrong. Please try again.';
        this.showToaster('We couldn\'t update AI assistant.', null, null, 'error');
      }
    },
    updateAssistant(data) {
      this.updatingAssistant = true;
      this.$eventBus.$emit('setBlockingOverlay', true);
      // console.log('DATA', { ...data });
      const assistantsFormSchemaBodyFormat = createFormSchemaBodyFormat(this.assistantsFormSchema.scheme);
      // console.log('FORMAT');
      // console.log(assistantsFormSchemaBodyFormat);
      // return;
      const assistantsFormSchemaBodyPopulated = populateFormBody(assistantsFormSchemaBodyFormat, data);
      const body = { data: assistantsFormSchemaBodyPopulated, includeMe: false };

      // TESTING schema repopulation -----------------------------
      // console.log('BODY');
      // console.log(body);
      // this.testPopulatedSchema = populateEmptySchema(this.assistantsFormSchema, body);
      // this.assistantSelected({ uid: 'aee6a0a7-1a22-4ba0-b7cf-1e470503bb5' }, body);
      // return;
      // TESTING schema repopulation --- END --------------------------


      const postActions = this.checkPostActions(data);
      const url = `/organisation/${this.currentOrganisation.id}/assistant/${this.assistantId}`;
      api('PUT', url, body, null, 'w')
        .then((response) => {
          if (postActions.length) {
            postActions.forEach((action) => {
              action.assistantId = this.assistantId;
              action.id = randomString(10);
              action.status = StatusTypes.PENDING;
            });
            this.addBackgroundActions(postActions);
            this.$nextTick(() => {
              // update all elements that implement postActions to reset
              this.$eventBus.$emit('resetPostActions');
            });
          }
          this.setNewSchemaValues(response.data);
          // Set new data as base data for changes comparison
          this.assistantsFormSchema = populateEmptySchema(this.assistantsFormSchema, body);
          this.editMessages = {};
          this.updateLocalAssistant({
            member_id: this.assistant.member_id,
            name: data['step-0'].name.data.value.value,
            avatar: data['step-0'].name.data.value.icon,
          });
          setTimeout(() => {
            if (response.data.messages && Array.isArray(response.data.messages)) {
              response.data.messages.forEach((message) => {
                this.showToaster(message.message, null, null, this.toasterTypeMap[message.type]);
              });
            }
            this.clearToggleElements();
            this.clearStepperDataStore();
            this.$eventBus.$emit('setBlockingOverlay', false);
            setTimeout(() => {
              this.updatingAssistant = false;
            }, 1000);
          }, 2000);
        })
        .catch((error) => {
          this.showCreateAssistantError(error);
          this.updatingAssistant = false;
          this.$eventBus.$emit('setBlockingOverlay', false);
        })
        .finally(() => {
          // this.updatingAssistant = false;
        });
    },
    checkPostActions(data) {
      // check if there are any post actions
      const postActions = [];
      const checkForPostActions = (dataSet) => {
        if (dataSet && dataSet.postAction && dataSet.dirty && dataSet.valid) {
          switch (dataSet.postAction) {
            case 'uploadAiFiles':
              if (!dataSet.data || !dataSet.data.files || !((dataSet.data.files.addFiles && dataSet.data.files.addFiles.length) || (dataSet.data.files.removeFiles && dataSet.data.files.removeFiles.length))) {
                return;
              }
              if (dataSet.data.files.addFiles && dataSet.data.files.addFiles.length) {
                postActions.push({
                  action: 'uploadAiFiles',
                  data: { files: dataSet.data.files.addFiles },
                  assistantId: this.assistantId,
                });
              }
              if (dataSet.data.files.removeFiles && dataSet.data.files.removeFiles.length) {
                postActions.push({
                  action: 'deleteAiFiles',
                  data: { files: dataSet.data.files.removeFiles },
                  assistantId: this.assistantId,
                });
              }
              return;
            default:
              break;
          }
          postActions.push({
            action: dataSet.postAction,
            data: dataSet.data,
            assistantId: this.assistantId,
          });
        } else if (this.isObject(dataSet)) {
          Object.keys(dataSet).forEach((key) => {
            checkForPostActions(dataSet[key]);
          });
        }
      };
      checkForPostActions(data);

      return postActions;
    },
    softReset(retryCount = 0) {
      this.loadingSchema = true;
      this.clearBackgroundActions();
      this.refreshPlayground()
        .catch((error) => {
          if (error.message === 'Network Error' && retryCount < 10) {
            setTimeout(() => {
              this.softReset(retryCount + 1);
            }, 1000);
          }
        });
    },
    reloadSchema(retryCount = 0) {
      this.getAssistantScheme(false)
        .then((response) => {
          this.assistantUpdatedCounter++;
          this.setNewSchemaValues(response.data);
          this.editMessages = {};

          // reset file upload specific counters
          localStorage.setItem('aifiles:nCC', 0);
          localStorage.setItem('aifiles:cO', null);
          setTimeout(() => {
            this.clearToggleElements();
            this.clearStepperDataStore();
          }, 2000);
        })
        .catch((error) => {
          if (error.message === 'Network Error' && retryCount < 10) {
            setTimeout(() => {
              this.softReset(retryCount + 1);
            }, 1000);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.full-screen-layout {
  display: flex;
  flex-direction: column;
  // justify-content: center;
  // align-items: center;
  background-color: $white;
  width: 100%;

  .icon-big {
    display: block;
    width: 16px;
    height: 16px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .header {
    height: 54px;
    padding: 15px;

    h1, h1 p {
      font-size: 18px;
      font-weight: bold;
      color: $blackPrimary;

      .green-pill {
        height: 22px;
        padding: 4px 12px 4px 11px;
        border-radius: 11px;
        background-color: #e2fdf9;
        font-size: 12px;
        font-weight: 500;
        color: #00bfa5;
      }
    }

    .btn {
      border-radius: 10px !important;
      padding-left: 13px !important;
      padding-right: 12px !important;
    }
  }

  #playground-wrapper {
    height: 1px;

    #assistant-editor {
      width: 630px;

      .stepper {
        padding: 0 20px;

        ::v-deep {
          .header {
            align-self: flex-start;
          }

          .step-slider {
            .step-wrapper {
              padding: 20px 0;

              .assistant-forms > h2, .assistant-forms > p {
                text-align: left
              }
            }
          }

          .footer {
            justify-content: flex-end;
            padding: 20px 0;
          }
        }
      }

      .overlay-controls.stepper {
        padding: 0 0 !important;
        ::v-deep {
          .image-counter {
            flex-shrink: 0;
            margin: 20px 20px 0;
          }

          .step-slider {
            padding: 0px 20px !important;
          }

          .footer {
            padding: 20px 20px !important;
          }
        }
      }
    }
  }

  .mask-spinner {
    position: absolute;
    background: $white;
    bottom: 0;
    height: unset;
    z-index: 99999;
    margin: 53px 0 0 0 !important;
    padding-top: 30px;
    // opacity: 0.5; // uncomment to make it transparent for debug
  }

  .body {
    overflow: hidden;
    padding: 0;

    &.no-messages {
      display: flex;
      align-items: center;
      justify-content: center;

      .baloon {
        font-size: 40px;
        margin-bottom: 15px;
      }

      .start-title, .start-title * {
        font-size: 18px;
        font-weight: 500;
        color: $blackPrimary;
        margin-bottom: 7px;
      }

      .start-title * {
        margin-bottom: 0px;
      }

      .start-subtitle {
        font-size: 14px;
        font-weight: 400;
        line-height: 1.2;
        color: $blackUltralight;
      }
    }

    .messages-scroll-area {
      min-height: 0 !important;
      height: unset !important;
      max-height: 100% !important;
      padding: 0 15px;

      .message-list {
        .assistant-name {
          font-size: 14px;
          font-weight: bold;
          color: $blackPrimary;

          .icon-big {
            width: 14px;
            height: 14px;
            margin-right: 5px;
          }
        }

        .conversation-start {
          margin-top: 30px !important;
          margin-bottom: 20px !important;

          .emoji-fix {
            font-size: 30px !important;
            margin-right: 0px !important;
          }
        }

        .day-wrapper {
          .time-flag {
            position: -webkit-sticky;
            position: sticky;
            top: 10px;
            display: flex;
            justify-content: center;
            margin-top: 0px;
            margin-bottom: 5px;
            z-index: 1;

            p {
              // font-family: 'InterSB' !important;
              font-size: 12px;
              font-weight: 500;
              line-height: 1 !important;
              color: $blackUltralight;
              background-color: $greyChatBubble;
              padding: 4px 15px;
              border-radius: 50px;
              box-shadow: 0 0 3px 0 rgb(48 54 70 / 30%);

              &.start-info {
                padding: 4px 5px;
              }
            }
          }

          .message-wrapper {
            display: flex;
            flex-direction: row-reverse;

            &:first-of-type {
              margin-top: 30px;
              &.small-top-margin {
                margin-top: 15px;
              }
            }

            &:last-of-type {
              padding-bottom: 30px;
            }

            &.error {
              margin-top: 0 !important;
              .message {
                .message-body {
                  background-color: $redPrimary;
                  border-color: $redPrimary;
                }
              }
            }

            &.activity {
              justify-content: center;
              .operator-message {
                font-size: 12px;
                font-weight: 500;
                line-height: 1.4;
                text-align: center;
                margin: 15px;
                color: $blackUltralight;

                .emoji-fix {
                  font-size: 12px !important;
                }
              }
            }

            .reply-message-origin {
              position: relative;

              &::before {
                content: '';
                position: absolute;
                border-left: 2px solid #7dbcfa;
                height: calc(100% - 18px);
                bottom: 0;
              }

              .header {
                font-size: 12px;
                color: $blackUltralight;
                margin: 15px 0 6px;
              }

              .body {
                border-radius: 15px;
                border: 2px solid $lightGray;
                overflow: hidden;
                margin-left: 9px;
                width: fit-content;
                white-space: pre-wrap;
                overflow-wrap: anywhere;

                .text-message {
                  background-color: $lightGray;
                  padding: 5px 10px;
                  width: fit-content;
                  font-size: 12px;
                  line-height: 1.2;

                  img {
                    width: 14px;
                    height: 14px;
                    margin: 0 1px;
                    vertical-align: -2px !important;
                  }
                }

                .media-message {
                  background-color: $lightGray;

                  .media-image {
                    width: 157px;
                    height: 157px;

                    .SB-lightbox-trigger.show-play-overlay {
                      background-size: 50px;
                    }
                  }

                  .caption {
                    font-size: 12px;
                    max-width: 157px;

                    img {
                      width: 14px;
                      height: 14px;
                      margin: 0 1px;
                      vertical-align: -2px !important;
                    }
                  }
                }

                .media-audio {
                  .audio-player {
                    padding: 4px 10px;
                    font-size: 12px;
                    background-color: $lightGray;

                    .sb-icon span.icon {
                      width: 9px;
                      height: 9px;
                      mask-size: 9px 9px !important;
                    }

                    .progress-wrapper {
                      margin-left: 12px;

                      .progress {
                        height: 2px;

                        &::after {
                          width: 6px;
                          height: 6px;
                          top: 4px;
                        }
                      }
                    }

                    .time {
                      min-width: 87px;
                    }
                  }
                }

                .media-file {
                  font-size: 12px;

                  a, .pdf-download {
                    font-size: 12px;
                    padding: 6px 12px 6px 7px;
                    // background-color: $blackUltralight;
                    // color: $greyChatBubble !important;

                    * {
                      // color: $greyChatBubble !important;
                    }

                    .sb-icon {
                      width: 13px;
                      height: 13px;
                      .icon.mask {
                        width: 13px;
                        height: 13px;
                        background-size: 13px;
                        mask-size: 13px 13px !important;
                        // background-color: $greyChatBubble !important;
                      }
                    }
                  }

                  .media-caption {
                    padding: 5px 10px!important;
                  }

                  &:not(.basic) {
                    a, .pdf-download {
                      background-color: #939FA3;
                      color: $white !important;

                      * {
                        color: $white !important;
                      }

                      .sb-icon {
                        .icon.mask {
                          background-color: $white !important;
                        }
                      }
                    }
                  }
                }

                .location-message {
                  /* 20% smaller than original */
                  a {
                    height: 120px;
                    width: 176px;
                  }
                }
              }

              margin-bottom: 6px;
            }

            .message {
              display: inline-block;
              max-width: 75%;

              .context-message {
                border: solid 1px #e1e7e9 !important;
                border-radius: 15px;
                background: $white;
                overflow: hidden;
                margin-top: 3px;
                margin-bottom: 3px;

                &.first {
                  border-bottom-right-radius: 3px;
                }
              }

              .sub-message {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                margin-top: 4px;
                margin-bottom: 7px;
                font-size: 12px;
                // line-height: 1.4;
                color: $blackUltralight;

                .ai-sources {
                  border-bottom: 1px dashed $blackUltralight;
                  padding-bottom: 2px;

                  &:hover, &.active {
                    cursor: default;
                    color: $blackPrimary;
                    border-bottom: 1px dashed $blackPrimary;

                    ::v-deep .sb-icon .mask {
                      background-color: $blackPrimary !important;
                    }
                  }
                }

                .avatar {
                  height: 14px;
                  width: 14px;
                  border-radius: 50px;
                  aspect-ratio: 1 / 1;
                  object-fit: cover;
                }

                .sender-icon{
                  height: 12px;
                  flex-shrink: 0;
                  margin-right: 4px;
                }

                .avatar {
                  margin-right: 4px;
                  position: relative;
                  // top: -1px;
                }

                .icon-submessage {
                  display: block;
                  width: 12px;
                  height: 12px;
                  background-position: center;
                  background-repeat: no-repeat;
                  background-size: contain;
                }
              }

              .message-actions {
                z-index: 99;
                .message-action {
                  margin-right: 5px;
                  opacity: 0;
                  display: none;
                  &.force {
                    opacity: 1;
                  }
                }

                .reaction-wrapper {
                  margin-left: -4px;
                  z-index: 9;
                  .reaction {
                    display: block;
                    border-radius: 50px;
                    margin-left: -4px;
                    width: 28px;
                    height: 28px;
                    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.25);
                    background-color: var(--white);
                    font-size: 14px;
                    // EMOJI DELETE - change this to 'pointer' when emoji delete becomes available on Gupshup
                    cursor: default;

                    &.contact {
                      cursor: default;
                    }

                    .remove-emoji {
                      opacity: 0;
                      position: absolute;
                      top: -4px;
                      right: -4px;
                    }

                    &:hover {
                      .remove-emoji {
                        opacity: 1;
                      }
                    }
                  }

                  &.to-right {
                    margin-left: 0px;
                    margin-right: -4px;

                    .reaction {
                      margin-left: 0px;
                      margin-right: -4px;
                    }
                  }
                }
              }
            }

            .message .message-body {
              white-space: pre-wrap;
              overflow-wrap: anywhere;
              max-width: max-content;
              margin-left: auto;
              margin-right: 0;
              margin-top: 1px;
              margin-bottom: 1px;
              border-radius: 3px;
              border-top-left-radius: 19px;
              border-bottom-left-radius: 19px;
              font-size: 14px;
              line-height: 1.2;
              color: $white;
              overflow: hidden;
              background: $bluePrimary;
              border: 3px solid $bluePrimary;
              width: 100%;
              max-width: 100%;

              &.failed {
                background: $redPrimary;
                border: 3px solid $redPrimary;
                color: $white !important;

                .audio-player {
                  background-color: $redPrimary;
                }
              }

              ::v-deep a {
                color: inherit !important;
                text-decoration: underline;
              }

              &.audio-message {
                border-top-left-radius: 10px;
                border-bottom-left-radius: 10px;
              }

              .text-message {
                padding: 4px 11px;
              }

              p img {
                width: 16px;
                height: 16px;
                margin: 0 1px;
                vertical-align: -3px !important;
              }

              &.first {
                border-top-right-radius: 19px;
              }
              &.last {
                border-bottom-right-radius: 19px;
              }

              &.audio-message.first {
                border-top-right-radius: 10px;
              }

              &.audio-message.last {
                border-bottom-right-radius: 10px;
              }

              &.has-buttons {
                border-bottom-right-radius: 3px;
                border-bottom-left-radius: 3px;
                margin-bottom: 0 !important;
                margin-left: unset !important;
                max-width: unset !important;
              }
            }

            .message .last {
              .button:last-of-type {
                border-radius: 3px 3px 18px 18px;
              }
            }

            &.outbound, &.template-message, &.bot {
              ::v-deep .media-message a {
                color: $white !important;
              }

              .message {
                .message-elements {
                  max-width: max-content;
                  // margin-left: auto;
                  justify-content: flex-end;

                  .message-info {
                    // margin: 0 -12px 0 3px;
                    position: absolute;
                    left: -24px;
                    top: calc(50% - 12px);
                  }
                }
                .message-body {
                  a {
                    color: inherit !important;
                    text-decoration: underline;
                  }
                }
              }
            }

            &.outbound {

              .reply-message-origin {
                .header {
                  justify-content: flex-end;
                }

                .body {
                  margin-left: auto;
                  margin-right: 9px;
                }

                &::before {
                  border-left: none;
                }

                &::after {
                  content: '';
                  position: absolute;
                  border-right: 2px solid #7dbcfa;
                  height: calc(100% - 18px);
                  bottom: 0;
                  right: 0;
                }
              }

              .body-wrapper {
                justify-content: flex-end;
              }
            }

            &.inbound {
              flex-direction: row;

              .message-elements {
                  min-width: fit-content;
                  max-width: calc(100% - 80px); // 80px is the width of the actions that show on hover + emoji reaction
                }

              .message {
                .body-wrapper {
                  flex-direction: row-reverse;
                  justify-content: flex-end;
                  .message-actions {
                    .message-action {
                      margin-left: 5px;
                      margin-right: 0;
                    }
                  }
                }
                .message-body {
                  margin-left: 0;
                  margin-right: auto;
                  background: $greyChatBubble;
                  border: 3px solid $greyChatBubble;
                  border-top-right-radius: 19px;
                  border-bottom-right-radius: 19px;
                  border-top-left-radius: 3px;
                  border-bottom-left-radius: 3px;
                  color: $blackPrimary;

                  a {
                    color: $blackPrimary !important;
                    text-decoration: underline;
                  }

                  &.first {
                    border-top-left-radius: 19px;
                  }
                  &.last {
                    border-bottom-left-radius: 19px;
                  }

                  .media-file:not(.basic) {

                    a, .pdf-download {
                      background-color: $blackUltralight;
                      color: $greyChatBubble !important;

                      * {
                        color: $greyChatBubble !important;
                      }

                      .sb-icon {
                        .icon.mask {
                          background-color: $greyChatBubble !important;
                        }
                      }
                    }
                  }
                }
                .sub-message {
                  justify-content: start;
                }
              }
            }

            &.unseen {
              padding-top: 42px;
              position: relative;
            }

            &.unseen::before {
              content: '';
              position: absolute;
              top: 20px;
              right: 0;
              left: 0;
              border-top: 1px solid $bluePrimary;
            }

            &.unseen::after {
              content: 'New';
              color: $bluePrimary;
              display: block;
              position: absolute;
              top: 14px;
              padding: 0 10px;
              left: calc(50% - 26px);
              text-align: center;
              background: $white;
              font-size: 12px;
              font-weight: 500;
            }

            // Prevents multiple unseen markers to be shown.
            &.unseen ~ .unseen {
              padding-top: 0 !important;
              &::before, &::after {
                display: none !important;
              }
            }

            &.small-top-margin {
              &.unseen {
                padding-top: 35px;
              }

              &.unseen::before {
                top: 13px;
              }

              &.unseen::after {
                top: 7px;
              }
            }

            &:hover {
              .body-wrapper.cloud-api .message-actions .message-action {
                display: inherit;
                opacity: 1;
              }
            }
          }

          &:last-of-type .activity:last-of-type {
            // margin-bottom: 30px;
          }
        }
      }
    }
  }

  .footer {
    margin: 0 15px 0 15px;

    * {
      font-size: 11px;
      font-weight: 400;
      line-height: 1.53;
      color: $blackUltralight;
    }

    .info {
      padding: 7px 15px 9px;
    }
  }
}

.action-text {
  color: $blackPrimary !important;
  font-size: 14px !important;
  font-weight: 400 !important;

  span {
    // color: $blackUltralight;
    // font-size: 14px !important;
    // font-weight: 500 !important;
  }
}

::v-deep {
  .emoji-picker {
    left: unset !important;
    top: unset !important;
  }

  .back-btn {
    &:hover {
      cursor: pointer;
      .sb-icon .icon.mask {
        background-color: $blackPrimary !important;
      }
    }
  }
}
</style>

<style lang="scss">
  .sources-popover {
    max-width: 415px;

    .popover-body {
      padding: 15px !important;
    }

    h3 {
      font-size: 14px;
      font-weight: 500;
      color: $bluePrimary;
    }

    a {
      border-bottom: 1px dashed $greyBorder;
      padding: 10px 0;
      color: $blackPrimary;

      &:hover {
        cursor: pointer;
      }

      &:last-of-type {
        border-bottom: none;
        padding: 9px 0 0;
      }

      p {
        line-height: 1 !important;
      }

      &:hover {
        .sb-icon .mask {
          background-color: $blackPrimary !important;
        }
      }
    }
  }
</style>
